<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-cancel value="同步模板" @cancel="syncTemplateWxTemplate" v-if="permissionCodes.indexOf('006001001') !== -1"/>
        <!--<button-add @click="toAddPage" />-->
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="消息名称" @search="searchKey" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @seeExample="seeExample" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @goToModifyPage="toModifyPage" @sendMessage="showSendMessageTip" @deleteLine="deleteLine" deleteTipInfo="是否确认删除该消息模板？" :operationArr="operationArr" />

    <el-dialog title="发送消息" :visible.sync="showSedMessageBox" width="860px">
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">副标题：</span>
        </div>
        <el-input v-model="sendMessageInfo.first" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="currentMessageTemplate.keyword1 && currentMessageTemplate.keyword1 !== '--'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{currentMessageTemplate.keyword1}}：</span>
        </div>
        <el-input v-model="sendMessageInfo.keyword1" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="currentMessageTemplate.keyword2 && currentMessageTemplate.keyword2 !== '--'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{currentMessageTemplate.keyword2}}：</span>
        </div>
        <el-input v-model="sendMessageInfo.keyword2" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="currentMessageTemplate.keyword3 && currentMessageTemplate.keyword3 !== '--'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{currentMessageTemplate.keyword3}}：</span>
        </div>
        <el-input v-model="sendMessageInfo.keyword3" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="currentMessageTemplate.keyword4 && currentMessageTemplate.keyword4 !== '--'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{currentMessageTemplate.keyword4}}：</span>
        </div>
        <el-input v-model="sendMessageInfo.keyword4" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="currentMessageTemplate.keyword5 && currentMessageTemplate.keyword5 !== '--'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{currentMessageTemplate.keyword5}}：</span>
        </div>
        <el-input v-model="sendMessageInfo.keyword5" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="sendMessageInfo.remark" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">关联公告<el-tooltip class="item" effect="dark" content="消息接收对象可点击消息跳转小程序公告页面" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>：</span>
        </div>
        <el-select v-model="sendMessageInfo.noticeCode" size="small" style="width: 280px">
          <el-option v-for="item in noticeList" :key="item.code"
                     :label="item.title" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">发送对象：</span>
        </div>
        <div>
          <div style="margin: 0 auto 20px">
            <el-radio-group v-model="sendMessageInfo.type" size="small">
              <el-radio-button label="ALL">所有人员</el-radio-button>
              <el-radio-button label="ADMIN">所有住户管理人员</el-radio-button>
              <el-radio-button label="">自定义</el-radio-button>
            </el-radio-group>
          </div>
          <div style="display: flex;justify-content: flex-start;flex-direction: column;" v-if="sendMessageInfo.type === ''">
            <div style="width: 280px;display: flex;justify-content: flex-start;flex-wrap: wrap;margin: 0 0 10px;align-items: center;" v-if="sendMessageInfo.enterpriseList.length > 0">
              <div style="color: #666666;">企业：</div>
              <el-tag
                v-for="(tag, index) in sendMessageInfo.enterpriseList"
                style="margin-right: 10px;"
                :key="tag.enterpriseName"
                closable
                @close="enterpriseClose(index)"
                :type="''">
                {{tag.enterpriseName}}
              </el-tag>
            </div>
            <div style="width: 280px;display: flex;justify-content: flex-start;flex-wrap: wrap;margin: 0 0 10px;align-items: center;" v-if="sendMessageInfo.personList.length > 0">
              <div style="color: #666666;">人员：</div>
              <el-tag
                v-for="(tag, index) in sendMessageInfo.personList"
                style="margin-right: 10px;"
                :key="tag.name"
                closable
                @close="personClose(index)"
                :type="''">
                {{tag.name}}
              </el-tag>
            </div>
            <div style="text-align: left"><i class="el-icon-circle-plus-outline" style="font-size: 20px;color: #00a0e6;cursor: pointer;" @click="showTip = true"></i></div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAthority" size="small">取 消</el-button>
        <el-button type="primary" @click="addAthority" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择对象" :visible.sync="showTip" width="792px">
      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick" v-if="showTip">
        <el-tab-pane label="选择住户" name="first" class="el_tab_item">
          <auth-tree ref="enterpriseTreeList" class="filter-tree" :update="treeUpdate"  />
        </el-tab-pane>
        <el-tab-pane label="选择人员" name="second">
          <!--远程搜索-->
          <el-input placeholder="姓名/手机号/所属住户" v-model="requestBody.searchKey" class="input-with-select" @keyup.13.native="getBasicPersonPage" size="small" style="margin-bottom: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="getBasicPersonPage" size="small" />
          </el-input>
          <el-table
            ref="multiplePersonTable"
            :data="authPersonData"
            tooltip-effect="dark"
            @select="selectPerson"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="75px">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号">
            </el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="所属住户">
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination background layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :total="personTotal" />
          </div>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelChoose" size="small">取 消</el-button>
        <el-button type="primary" @click="addChoose" size="small">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="消息示例" :visible.sync="messageDialog" width="600px" style="text-align: left">
      <div class="message-dialog-box">
        <h3 >{{messageData.typeText}}</h3>
        <div class="messageDataFirst">{{messageData.first}}</div>
        <div class="messageMain">
          <div class="messageMainLine">
            <!--<div class="message_title">{{messageData.title}}:</div>-->
            <div class="message_info">{{messageData.meaningArr[0]}}</div>
          </div>
          <div class="messageMainLine">
            <div class="message_title">{{messageData.keyword1}}:</div>
            <div class="message_info">{{messageData.meaningArr[1]}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.keyword2">
            <div class="message_title">{{messageData.keyword2}}:</div>
            <div class="message_info">{{messageData.meaningArr[2]}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.keyword3">
            <div class="message_title">{{messageData.keyword3}}:</div>
            <div class="message_info">{{messageData.meaningArr[3]}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.keyword4">
            <div class="message_title">{{messageData.keyword4}}:</div>
            <div class="message_info">{{messageData.meaningArr[4]}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.keyword5">
            <div class="message_title">{{messageData.keyword5}}:</div>
            <div class="message_info">{{messageData.meaningArr[5]}}</div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Message'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import {nError, nSuccess} from '../../../utils/notice'
  import AuthTree from '../../../components/common/auth-tree'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      AuthTree,
      ButtonAdd,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      Breadcrumb},
    name: 'message-template-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧消息',
          name: 'message-template-manage'
        }, {
          value: '消息模板'
        }],
        exportUrl: '',
        addPageName: 'message-template-add',
        tableHead: [{
          prop: 'title',
          label: '模板名称'
        }, {
          prop: '',
          example: true,
          label: '示例'
        }],

        operationArr: ['sendMessage', 'delete'],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        uploadUrl: '',
        selectionArr: [],
        requestData: {
          searchKey: '',
        },

        allEnterpriseList: [],
        enterpriseList: [],
        personList: [],
        wantPersonList: [],
        pageSelectPerson: [],
        requestBody: {
          pageNum: 1,
          pageSize: 10,
          searchKey: ''
        },
        personTotal: 0,
        activeName2: 'first',
        authPersonData: [],

        showSedMessageBox: false,

        showTip: false,
        treeUpdate: {
          render: () => {
            return api.getEnterpriseInfoList()
              .then(list => {
                list.forEach(tree => {
                  tree._label = tree.enterpriseName
                })
                return list
              })
          }
        },
        personAuth: false,
        departmentAuth: true,
        adsStr: '',
        currentMessageTemplate: '',

        messageDialog: false,
        messageData: {
          meaningArr: []
        },

        noticeList: [],

        sendMessageInfo: {
          type: '',
          templateId: '',
          first: '',
          keyword1: '',
          keyword2: '',
          keyword3: '',
          keyword4: '',
          keyword5: '',
          remark: '',
          personList: [],
          enterpriseList: [],
          noticeCode: '',
          noticeUrl: ''
        },


      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.uploadUrl = api.importPaymentItemBill
      this.getPage()
      this.getNoticeList()
      // this.getBasicPersonPage()
      this.getEnterpriseInfoList()
    },
    activated() {
      this.getPage()
      this.getNoticeList()
      this.getEnterpriseInfoList()
    },
    methods: {
      // 获取公告列表
      getNoticeList () {
        this.$axios.post(api.getNoticeList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.noticeList = res.data.data
            }
          })
          .catch(errorHandler('获取公告失败'))
      },
      // 获取所有住户列表
      getEnterpriseInfoList () {
        api.getEnterpriseInfoList()
          .then(list => {
            this.allEnterpriseList = list
            console.log(this.sendMessageInfo)
            // this.sendMessageInfo.enterpriseList.map(v => {
            //   console.log(v)
            //   this.$refs.enterpriseTreeList.setCheckedKeys([v.code])
            // })
          })
          .catch(errorHandler('获取数据失败'))
      },
      getBasicPersonPage () {
        api.getBasicPersonPage(this.requestBody)
          .then((data) => {
            this.personTotal = data.total
            this.authPersonData = data.list
            console.log(this.sendMessageInfo)
            this.$refs.multiplePersonTable.clearSelection()
            // let chooseIndexArr = []
            // this.wantPersonList = this.sendMessageInfo.personList
            // this.authPersonData.map((v,i) => {
            //   this.wantPersonList.map(want => {
            //     if (want.code === v.code) {
            //       // chooseIndexArr.push(i)
            //       this.$refs.multiplePersonTable.toggleRowSelection(this.authPersonData[i]);
            //     }
            //   })
            // })
            // if (chooseIndexArr.length > 0) {
            //   chooseIndexArr.forEach(index => {
            //
            //   })
            // } else {
            //
            // }
          })
      },
      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      // 同步模板
      syncTemplateWxTemplate() {
        this.$axios.get(api.syncTemplateWxTemplate, {})
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('同步成功')
              this.pageNum = 1
              this.getPage()
            }
          })
          .catch(errorHandler('获取模板失败'))
      },
      toAddPage () {
        this.$router.push({
          name: 'message-template-add'
        })
      },
      toModifyPage (code) {
        this.$router.push({
          path: '/message_template_modify/' + code
        })
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getWxTemplatePage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map((v, i) => {
                v.code = v.templateId
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      // 删除模板消息
      deleteLine (code) {
        this.$axios.post(api.deleteWxTemplate, code)
          .then(res => {
            nSuccess('删除成功')
            this.getPage()
          })
          .catch(errorHandler('删除失败'))
      },

      // 发送消息
      showSendMessageTip (data) {
        this.currentMessageTemplate = data
        this.sendMessageInfo.templateId = data.templateId
        this.showSedMessageBox = true
      },
      handleClick (tab) {
        if (tab.index === '0') {
          this.personAuth = false
          this.departmentAuth = true
        } else {
          this.personAuth = true
          this.departmentAuth = false
        }
      },
      // 选择人员
      selectPerson (selection) {
        console.log(selection)

      },
      handleSelectionChange (selection) {
        console.log(selection)
        this.authPersonData.map(person => {
          this.wantPersonList.map((wantPerson, wantPersonIndex) => {
            if (wantPerson.code === person.code) {
              this.wantPersonList.splice(wantPersonIndex, 1)
            }
          })
        })
        selection.map(select => {
          let hasPerson = false
          this.wantPersonList.map(want => {
            if (want.code === select.code) {
              hasPerson = true
            }
          })
          if (!hasPerson) {
            this.wantPersonList.push(select)
          }
        })
      },
      cancelChoose () {
        this.showTip = false
        // this.$refs.red._self.$refs.tree.setCheckedNodes([])
      },
      addChoose () {
        let enterpriseCodeStr = window.sessionStorage.getItem('changeAuthDep')
        let enterpriseList = this.enterpriseList
        if (enterpriseCodeStr) {
          let oldCodeArr = []
          enterpriseList.map(old => {
            oldCodeArr.push(old.code)
          })
          this.allEnterpriseList.map(enterprise => {
            if (enterpriseCodeStr.indexOf(enterprise.code) !== -1 && oldCodeArr.indexOf(enterprise.code) === -1) {
              enterpriseList.push(enterprise)
            }
          })
        }
        this.sendMessageInfo.enterpriseList = enterpriseList
        this.sendMessageInfo.personList = this.wantPersonList
        window.sessionStorage.setItem('changeAuthDep', '')
        this.showTip = false
      },
      enterpriseClose (index) {
        this.sendMessageInfo.enterpriseList.splice(index, 1)
      },
      personClose (index) {
        this.sendMessageInfo.personList.splice(index, 1)
      },
      cancelAthority () {
        this.sendMessageInfo = {
          templateId: '',
          first: '',
          keyword1: '',
          keyword2: '',
          keyword3: '',
          keyword4: '',
          keyword5: '',
          remark: '',
          personList: [],
          enterpriseList: []
        }
        this.showSedMessageBox = false
      },
      addAthority () {
        if (!this.sendMessageInfo.first) {
          nError(`请输入副标题`)
          return false
        }
        if (this.currentMessageTemplate.keyword1 && this.currentMessageTemplate.keyword1 !== '--' && !this.sendMessageInfo.keyword1) {
          nError(`请输入${this.currentMessageTemplate.keyword1}`)
          return false
        }
        if (this.currentMessageTemplate.keyword2 && this.currentMessageTemplate.keyword2 !== '--' && !this.sendMessageInfo.keyword2) {
          nError(`请输入${this.currentMessageTemplate.keyword2}`)
          return false
        }
        if (this.currentMessageTemplate.keyword3 && this.currentMessageTemplate.keyword3 !== '--' && !this.sendMessageInfo.keyword3) {
          nError(`请输入${this.currentMessageTemplate.keyword3}`)
          return false
        }
        if (this.currentMessageTemplate.keyword4 && this.currentMessageTemplate.keyword4 !== '--' && !this.sendMessageInfo.keyword4) {
          nError(`请输入${this.currentMessageTemplate.keyword4}`)
          return false
        }
        if (this.currentMessageTemplate.keyword5 && this.currentMessageTemplate.keyword5 !== '--' && !this.sendMessageInfo.keyword5) {
          nError(`请输入${this.currentMessageTemplate.keyword5}`)
          return false
        }
        if (!this.sendMessageInfo.remark) {
          nError(`请输入备注`)
          return false
        }
        if (!this.sendMessageInfo.type && this.sendMessageInfo.personList.length === 0 && this.sendMessageInfo.enterpriseList.length === 0) {
          nError('请选择发送对象')
          return false
        }
        this.noticeList.map(v => {
          if (v.code === this.sendMessageInfo.noticeCode) {
            this.sendMessageInfo.noticeUrl = v.url
          }
        })
        this.$axios.post(api.sendCustomMessage, this.sendMessageInfo)
          .then(res => {
            nSuccess('发送成功')
            this.sendMessageInfo = {
              templateId: '',
              first: '',
              keyword1: '',
              keyword2: '',
              keyword3: '',
              keyword4: '',
              keyword5: '',
              remark: '',
              personList: [],
              enterpriseList: []
            }
            this.showSedMessageBox = false
            this.wantPersonList = []
          })
          .catch(errorHandler('发送失败'))
      },

      handleCurrentChange (val) {
        this.requestBody.pageNum = val
        this.getBasicPersonPage()
      },

      // 查看模板示例
      seeExample(data) {
        for (let i in data) {
          if (data[i] === '--') {
            data[i] = ''
          }
        }
        data.meaningArr = data.example.split('\n')
        data.meaningArr.map((v, i) => {
          if (v) {
            if (v.indexOf('：') !== -1) {
              let valueArr = v.split('：')
              data.meaningArr[i] = valueArr[1]
            }
          } else {
            data.meaningArr.splice(i, 1)
          }
        })
        this.messageData = data
        this.messageDialog = true
        console.log(data)
      }
    },

    watch: {
      showTip (val) {
        if (val === true) {
          if (this.activeName2 === 'first') {
            // this.getEnterpriseInfoList()
            // this.$refs.enterpriseTreeList.setCheckedKeys([])
          } else {
            this.getBasicPersonPage()
            // this.$refs.multiplePersonTable.clearSelection()
          }
        }
      },

      activeName2 (val) {
        if (val === 'first') {
          let enterpriseKey = []
          this.sendMessageInfo.enterpriseList.map(enterprise => {
            enterpriseKey.push(enterprise.code)
          })
          this.$nextTick(() => {
            this.$refs.enterpriseTreeList.setCheckedKeys([])
            setTimeout(() => {
              this.$refs.enterpriseTreeList.setCheckedKeys(enterpriseKey)
            }, 50)
          })

        } else {
          this.getBasicPersonPage()
          // this.$refs.multiplePersonTable.clearSelection()
        }
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }

  .form-line {
    width: 480px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .message-dialog-box {
    width: 500px;
    margin: 0 auto 30px;
    text-align: left;
    .messageDataFirst {
      color: #999999;
      margin-bottom: 30px;
    }
    .messageMainLine {
      display: flex;
      justify-content: flex-start;
      align-items: start;
      font-size: 16px;
      line-height: 30px;
      margin: 10px 0;
      .message_title {
        width: 100px;
        color: #999999;
      }
      .message_info {
        width: 400px;
        color: #173177;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/MessageService/MessageTemplate/MessageTemplateManage.vue